import Hero, { Description, Title } from './Hero';

function PageTitle() {

  return (
    <Hero>
      <Title>ALV-työkalu</Title>
      <Description>Yksinkertainen ALV-laskuri</Description>
    </Hero>
  );
}

export default PageTitle;
